// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,

  imageSize: 1000000,
  fileSize: 100000000,
  csvFileSize: 1000000,

    // enable this code while deploying on the Migration server
    //api_url: 'https://test-elms.cloudnowtech.net/core/api/v1/hbfx-insta-authentication',  // user ,organisations, roles
    //api_url1: 'https://test-elms.cloudnowtech.net/core/api/v1/hbfx-cnt-elms',       /// Category , and course,lesson,
    //api_urlFor_tocheck_statusof_lesson:'https://test-elms.cloudnowtech.net/core/api/v1/hbfx-cnt-elms-scheduler',

    //cloudPath:'https://storage.googleapis.com/elms-uploads/Organisation',

  // enable this code while deploying on LIVE server
   api_url: 'https://elms.hornbillfx.com/core/api/v1/hbfx-insta-authentication',  // user ,organisations, roles
   api_url1: 'https://elms.hornbillfx.com/core/api/v1/hbfx-cnt-elms',       /// Category , and course,lesson
   api_urlFor_tocheck_statusof_lesson:'https://scheduler.hbxlabs.com/core/api/v1/hbfx-cnt-elms',

   cloudPath:'https://storage.googleapis.com/elms-prod-hbfx/Organisation',
  // ftpHost: 'https://elms.hornbillfx.com',
  // ftpRootDir: '/developer/elms/Organisation',

  // enable this code while deploying on SandBox Live
    // api_url: 'https://demo.elms.hornbillfx.com/core/api/v1/hbfx-insta-authentication',  // user ,organisations, roles
    // api_url1: 'https://demo.elms.hornbillfx.com/core/api/v1/hbfx-cnt-elms',       /// Category , and course,lesson,
    // api_urlFor_tocheck_statusof_lesson:'https://demo.elms.hornbillfx.com/core/api/v1/hbfx-cnt-elms-scheduler',

    // cloudPath:'https://storage.googleapis.com/elms-demo-sandbox/Organisation',


};



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/environments/environment.ts